import { gql } from "@apollo/client";

export const GENERATE_COMPLETED_REVENUE_REPORT = gql`
  query generateRevenueReport($fromDate: String!, $toDate: String!) {
    generateRevenueReport(fromDate: $fromDate, toDate: $toDate) {
      key
      message
    }
  }
`;